import { Spinner } from '@studio/design-system/spinner';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { ThumbnailProps } from './types.js';

/** `<Thumbnail>` component. */
export const Thumbnail = ({ className, image, title, ...props }: ThumbnailProps): ReactElement => (
  <div
    className={twMerge(
      'aspect-video min-h-[116px] min-w-[206px] select-none rounded-t-inherit bg-base-100',
      !image && 'grid place-items-center',
      className
    )}
    {...props}
  >
    {image ? (
      <img alt={title} className='rounded-t-inherit' draggable={false} src={image} />
    ) : (
      <Spinner className='text-[32px] text-primary' />
    )}
  </div>
);
